import {connect} from 'react-redux';
import EntryDetailCoordinatorModal from './EntryDetailCoordinatorModal.jsx';
import {
  handleCoordinatorSave,
  handleEntryDetailCoordinatorUpdateCancelClick,
  validateEntryCoordinatorDetailForm
} from './actions';

const mapStateToProps = state => ({
  visible: state.admin.entryDetail.showEntryDetailCoordinatorModal,
  ...state.admin.entryDetail.coordinator
});

const mapDispatchToProps = dispatch => ({
  onCancelClick: () => dispatch(handleEntryDetailCoordinatorUpdateCancelClick()),
  onSubmit: data => dispatch(handleCoordinatorSave(data)),
  validate: validateEntryCoordinatorDetailForm
});

export default connect(mapStateToProps, mapDispatchToProps)(EntryDetailCoordinatorModal);



// WEBPACK FOOTER //
// ./src/features/admin/entryDetail/EntryDetailCoordinatorModalContainer.jsx